import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  EventEmitter,
  Output
} from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BuletineTableService } from 'src/app/modules/acbcr/common/services/buletine-table.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { NotaControlCppcService } from 'src/app/modules/acbcr/common/services/nota-control-cppc.service'

@Component({
  selector: 'app-add-edit-nota-control-cppc',
  templateUrl: './add-edit-nota-control-cppc.component.html',
  styleUrls: ['./add-edit-nota-control-cppc.component.scss']
})
export class AddEditNotaControlCppcComponent {
  @ViewChild('notaControlCPPCModal') notaControlCPPCModal: ElementRef;
  @Input() modalData = {};
  @Output() notifyClose = new EventEmitter();

  notaControlCPPCForm = new UntypedFormGroup({});
  modalReference: NgbModalRef;
  isSuperAdmin = false;
  isAdmin = false;
  isOperator = false;
  readonly = false;
  operatori;
  fileName;

  constructor(
    public modalService: NgbModal,
    private helperDataService: HelperDataService,
    private buletinTabelService: BuletineTableService,
    private notaControlCppcService: NotaControlCppcService,
  ) { }

  ngOnInit() {
    this.isSuperAdmin = UIHelper.isSuperAdmin();
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
  }

  ngOnChanges(changes) {
    if (changes.modalData && this.modalData) {
      if (this.modalData['id']) {
        this.notaControlCppcService.getAPI({ id: this.modalData['id'] })
          .subscribe({
            next: (response) => {
              this.buildForm(response);
              this.openModal();
            }
          })
      } else {
        this.buildForm(this.modalData);
        this.openModal();
      }

      if (!this.operatori) {
        this.buletinTabelService.operatoriAPI().subscribe(
          (response) => {
            this.operatori = response;
          });
      }
    }
  }

  onSubmitted() {
    this.notaControlCppcService.saveAPI(this.notaControlCPPCForm.value)
      .subscribe({
        next: (response) => {
          this.modalReference.close();
          this.notifyClose.emit(true);
        }
      })
  }

  openModal() {
    this.modalReference = this.modalService.open(this.notaControlCPPCModal, {
      windowClass: 'modal-half-full',
      scrollable: true,
    });
  }

  buildForm(formData) {
    this.readonly = formData['readonly'];
    this.fileName = formData['file_name'];
    this.notaControlCPPCForm = new UntypedFormGroup({
      id: new UntypedFormControl(formData['id']),
      exploatatie_id: new UntypedFormControl(formData['exploatatie_id']),
      data: new UntypedFormControl(formData['data_dmy']),
      numar: new UntypedFormControl(formData['numar']),
      operator_id: new UntypedFormControl(formData['operator_id']),
      file_id: new UntypedFormControl(formData['file_id']),
    });
  }

  onDataChanged(event) {
    if (this.notaControlCPPCForm) {
      this.notaControlCPPCForm.controls.data.setValue(event);
    }
  }

  uploadServerResponse(event) {
    const file = event.body.files[0];
    this.fileName = file.file_uploaded_name;
    this.notaControlCPPCForm.controls.file_id.setValue(file.file_id);
  }

  downloadFile(event) {
    event.target.disabled = true;
    let fileId = this.notaControlCPPCForm.value.file_id;

    this.helperDataService.downloadFile(fileId)
      .subscribe({
        next: (response: any) => {
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, this.fileName);
          event.target.disabled = false;

        }
      });
  }

  deleteFile() {
    this.notaControlCPPCForm.controls.file_id.setValue(null);
    this.fileName = null;
  }
}
